// @flow
import React from 'react';
import {
  DateTime,
} from 'luxon';

import type {
  IntervalType,
} from 'chronos-types';

import {
  Cell, MonthDay, WeekDay,
} from './styled';


function getCellType(date, selected) {
  if (selected) return 'selected';
  if (date.hasSame(DateTime.local(), 'day')) return 'today';
  if (/^(6|7)$/.test(date.weekday)) return 'week';
  return '';
}

type Props = {
  style: Object,
  columnIndex: number,
  currentDate: IntervalType,
  selectedColumns: Array<number>,
  onSelect: { (): void },
}

const GridHeaderCellRenderer = ({
  style,
  columnIndex,
  currentDate,
  selectedColumns,
  onSelect,
}: Props) => {
  const date = currentDate.start.plus({ days: columnIndex });
  const weekDay = date.toFormat('ccc');
  const monthDay = date.toFormat('dd');
  const selected = selectedColumns.some(d => d.hasSame(date, 'day'));
  return (
    <Cell
      style={{
        ...style,
        userSelect: 'none',
      }}
      onClick={(e) => {
        onSelect(date, e);
      }}
      type={getCellType(date, selected)}
    >
      <MonthDay>{monthDay}</MonthDay>
      <WeekDay>{weekDay}</WeekDay>
    </Cell>
  );
};

export default GridHeaderCellRenderer;
